import { useQuery, UseQueryResult } from 'react-query'
import { request } from 'Features/auth/axios-client'
import { AdherenceReportData } from 'Features/AdherenceReport/AdherenceReport.types'

const fetchAdherenceReport = async (lagNumber: number) => {
  const {data} =  await request({
    url: `lag/${lagNumber.toString()}/adherence-report`,
    method: 'get',
  })

  return data
}

export const useAdherenceReport = (
  lagNumber: number
): UseQueryResult<AdherenceReportData[]> => {
  return useQuery(['adherence-report', lagNumber], () => fetchAdherenceReport(lagNumber), {
    select: ({ data }) => data,
    enabled: lagNumber !== undefined,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })
}
